/*
 * Dummy service, for temporarily pass values to transitOrderSummary route
 */
angular.module('posApp').factory('transitOrderSummary', () => {
  const transitOrderSummary = {};

  return transitOrderSummary;
});
